import { ClientOption } from '../board.types';

export const BOARD_CLIENT_OPTIONS: ClientOption[] = [
  { id: 2, name: 'Postobon' },
  { id: 4, name: 'Lucro-dev' },
  { id: 5, name: 'Alpina' },
  { id: 37, name: 'Bepensa' },
  { id: 70, name: 'Femsa' },
  { id: 6, name: 'Ramo' },
  { id: 7, name: 'Bepensa Rep. Dominicana' },
  { id: 71, name: 'Eficacia' },
  { id: 104, name: 'Harmony' },
  { id: 137, name: 'Bivien' }
];
